import { gql } from '@apollo/client';


export const GET_OFFENSE_VIOLATIONS = gql`
query GET_OFFENSE_VIOLATIONS($timestamp: String, $noSessionReset: Boolean) {
  getOffenseViolationPrototypes(timestamp: $timestamp, noSessionReset: $noSessionReset) {
      id
      maxPenalty
      minPenalty
      name
      fullName
      inactive
      offenseCategory {
        id
        name
        oriId
        position
      }
      offenseSubCategory {
        id
        name
        oriId
        position
      }
      oriId
      points
      waiver
      position
      yoe
    }
}
`;